import React, { useState } from "react";
import {
  Button, Checkbox, Dialog, DialogActions, DialogContent, 
  DialogTitle, FormControlLabel, Box, Divider, Typography
} from "@mui/material";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import DoneIcon from "@mui/icons-material/Done";
import SearchFanpageForm from "../../Fanpages/Posts/Components/SearchFanpageForm";

const DialogSelectGroupFanpages = ({
  listGroupFanpages = [],
  handleChangeGroupFanpage,
  groupFanpageSelected = [],
  autoSave = false,
  buttonSize = "medium",
  className = "",
}) => {
  const [open, setOpen] = useState(false);
  const [filtered, setFiltered] = useState([]);
  const [selected, setSelected] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  // Bổ sung state limit để quản lý load more
  const [limit, setLimit] = useState(20);  
  

  // Chỉ nạp dữ liệu khi người dùng chủ động nhấn nút "Chọn Fanpage"
  const handleOpen = () => {
    setSelected(groupFanpageSelected); // Lấy dữ liệu từ cha truyền vào
    setFiltered(listGroupFanpages);    // Reset danh sách hiển thị
    setIsSearching(false);
    setLimit(20); // Reset limit về mặc định khi mở dialog
    setOpen(true);
  };

  const handleSearch = (term) => {
    const text = term.toLowerCase().trim();
    
    if (!text) {
      setFiltered(listGroupFanpages);
      setIsSearching(false);
      setLimit(20); // Reset limit khi xóa search
      return;
    }
    const result = listGroupFanpages.filter((item) => {
      const name = (item.name || "").toLowerCase();
      return name.includes(text) || String(item.id).includes(text);
    });
    setFiltered(result);
    setIsSearching(true);
    setLimit(20); // Reset limit khi bắt đầu search mới
  };

  const handleToggle = (group) => {
    const idStr = String(group.id);
    const isExist = selected.some((item) => String(item.id) === idStr);
    
    let newSelected;
    if (!isExist) {
      newSelected = [...selected, group];
    } else {
      newSelected = selected.filter((item) => String(item.id) !== idStr);
    }

    setSelected(newSelected);
    // Nếu autoSave = true thì cập nhật trực tiếp cho cha
    if (autoSave) handleChangeGroupFanpage(newSelected);
  };

  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    const newSelected = isChecked ? [...listGroupFanpages] : [];
    setSelected(newSelected);
    if (autoSave) handleChangeGroupFanpage(newSelected);
  };

  const handleConfirm = () => {
    handleChangeGroupFanpage(selected); // Trả dữ liệu về cho cha
    setOpen(false);
  };

  // Hàm xử lý tăng limit để load thêm page
  const handleLoadMore = () => {
    setLimit((prev) => prev + 20);
  };

  return (
    <Box>
      <Button startIcon={<AddRoundedIcon />} variant="contained" onClick={handleOpen}
        size={buttonSize} className={className}
      >
        Chọn Nhóm Fanpage
      </Button>

      <Dialog open={open} fullWidth maxWidth="md" onClose={() => setOpen(false)} disableEnforceFocus>
        <DialogTitle>
          <Box sx={{ mb: 1, fontWeight: 'bold' }}>Danh sách nhóm Fanpage</Box>
          <SearchFanpageForm onSearch={handleSearch} placeholder="Tìm kiếm nhóm fanpage..." />
        </DialogTitle>
        <Divider />
        <DialogContent sx={{ minHeight: "400px" }}>
          <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}>
            {!isSearching && (
              <FormControlLabel
                sx={{ gridColumn: "span 2", borderBottom: "1px dashed #ccc", pb: 1 }}
                control={
                  <Checkbox 
                    checked={listGroupFanpages.length > 0 && selected.length === listGroupFanpages.length} 
                    onChange={handleSelectAll} 
                  />
                }
                label={<strong>Chọn tất cả ({listGroupFanpages.length})</strong>}
              />
            )}

            {/* Sử dụng slice để chỉ hiển thị số lượng theo limit */}
            {filtered.slice(0, limit).map((group) => {
              const isChecked = selected.some(
                (item) => String(item.id) === String(group.id)
              );

              return (
                <FormControlLabel
                  key={group.id}
                  control={
                    <Checkbox 
                      checked={isChecked} 
                      onChange={() => handleToggle(group)} 
                    />
                  }
                  label={`Nhóm ${group?.name} (${group.id})`}
                />
              );
            })}
          </Box>

          {/* Hiển thị nút Load More khi số lượng item vượt quá limit */}
          {filtered.length > limit && (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
              <Button 
                variant="outlined" 
                onClick={handleLoadMore}
                sx={{ borderRadius: '20px', textTransform: 'none' }}
              >
                Xem thêm ({filtered.length - limit} nhóm fanpage)
              </Button>
            </Box>
          )}

          {filtered.length === 0 && (
            <Typography align="center" sx={{ mt: 10 }} color="textSecondary">
              Không tìm thấy kết quả phù hợp
            </Typography>
          )}
        </DialogContent>
        <Divider />
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => setOpen(false)} variant="contained" color="inherit">Hủy</Button>
          <Button startIcon={<DoneIcon />} variant="contained" onClick={handleConfirm}>
            Xác nhận đã chọn ({selected.length})
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default DialogSelectGroupFanpages;